import { render, staticRenderFns } from "./Pta.vue?vue&type=template&id=3f7b0af1"
import script from "./Pta.vue?vue&type=script&lang=js"
export * from "./Pta.vue?vue&type=script&lang=js"
import style0 from "./Pta.vue?vue&type=style&index=0&id=3f7b0af1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports